import React from "react";
import Sidebar from "./Sidebar";
import "./App.css";
import Chat from "./Chat";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useState } from "react";
import  Login  from './Login';
import { useStateValue } from "./StateProvider";

function App() {


  // const [user,setUser]= useState();
const [{user}, dispatch] = useStateValue();  

  return (
    <div className="app">
      /{" "}
      <div className="app__body">

      {
        user? (
          <Router>
          <Sidebar />
          <Switch>
            <Route path="/rooms/:roomId">
              <Chat />
            </Route>
            <Route path="/">{/* <Sidebar /> */}</Route>
          </Switch>
        </Router>
        ): <Login/>
      }     
      </div>
    </div>
  );
}

export default App;
